import {Product} from "../models/product";
import {FilterMap, ProductFilter} from "../models/filter";
import {productService} from "./product-service";
import {Query, QueryState} from "../models/query";
import {customerService} from "./customer-service";

export class QueryController {
  public offset: number = 0;
  public limit: number = 30;
  public totalCount: number = -1;
  public products: Product[] = [];
  public filterMap: FilterMap;

  constructor(filterMap: FilterMap, state: QueryState) {
    this.filterMap = filterMap;
    this.limit = state.limit;
    this.offset = state.offset;
    this.products = state.items;
    this.totalCount = state.totalCount;
  }

  public async doQuery(reset: boolean = false): Promise<QueryState> {

    if (reset) {
      this.products = [];
      this.offset = 0;
      this.limit = 30;
      this.totalCount = -1;
    }

    //if likes filter is selected use different loadProducts call
    const isLikeSelected = this.filterMap.likes[0]?.selected;
    if (isLikeSelected) {
      return this.loadLikedProducts();
    }

    //if collection is present in filterMap use new backend call to load it with the correct product information
    const selectedCollections = this.filterMap.collections.filter(c => c.selected)
    if (selectedCollections.length > 0) {
      return this.loadCollections(selectedCollections);
    }

    //if an editorial is selected, then no operation is performed since the loading of editorials is handled in the <Editorial/> component
    const selectedEditorials = this.filterMap.editorials.find(c => c.selected);
    if (selectedEditorials) {
      return new QueryState(-1, [], 0, 30)
    }

    const q = this.createQuery();
    const result = await productService.loadProducts(q);

    this.totalCount = result.totalCount;

    this.products.push(...result.items);

    return new QueryState(this.totalCount, this.products, this.limit, this.offset);
  }

  private async loadCollections(selectedCollections: ProductFilter[]) {
    const ids = selectedCollections.map(collection => collection.value).join(',');
    const collections = await productService.loadCollections(ids, this.filterMap.country);
    const products: Product[] = [];
    collections.forEach(c => products.push(...c.extractProducts(true)));
    return new QueryState(products.length, products, products.length, 0);
  }

  public async applyFilters(filterMap: FilterMap): Promise<QueryState> {
    this.filterMap = filterMap;
    this.offset = 0;

    window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
    return this.doQuery(true);
  }

  public async loadNext(): Promise<QueryState> {
    if ((this.offset + this.limit) < this.totalCount) {
      this.offset += this.limit;
      return this.doQuery();
    }

    return Promise.reject(false);
  }

  private async loadLikedProducts(): Promise<QueryState> {
    const likes = await customerService.loadLikesForUser();
    return await productService.loadProductsForLikes(likes, this.filterMap.country);
  }

  private createQuery(): Query {
    let q = new Query();
    q.limit = this.limit;
    q.offset = this.offset;

    const filters = this.filterMap.getQueryFilters();
    if (filters) {
      q.filters = filters;
    }
    return q;
  }
}